import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import React from "react";

import { WrapMeWith } from "@/common/components/wrap-me-with/wrap-me-with";

import { BindingOfferDialog } from "./binding-offer-dialog";

type BindingOfferSellDialogProps = {
  traderName: string;
  cropName: string;
  amount: string;
  quarter: string;
  postalCodeLabel: string;
  parameters?: string;
  unitPrice: string;
  tocUrl?: string | null;
  isPending: boolean;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: () => void;
};

const BindingOfferSellDialog = ({
  postalCodeLabel,
  tocUrl,
  ...props
}: BindingOfferSellDialogProps) => {
  return (
    <BindingOfferDialog
      {...props}
      confirmLabel={<Trans>Prodat</Trans>}
      introText={
        <Trans>
          Prodávající tímto činí závazný návrh na uzavření kupní smlouvy o
          prodeji zboží v reakci na rámcovou poptávku kupujícího, a to za
          následujících podmínek:
        </Trans>
      }
      legalConsentText={
        <Trans>
          Prodávající souhlasí s tím, že obsah kupní smlouvy se bude řídit{" "}
          <WrapMeWith
            when={!!tocUrl}
            wrapper={(children) => (
              <a
                className="text-can-forest-teal underline"
                href={tocUrl!}
                rel="noreferrer"
                target="_blank"
              >
                {children}
              </a>
            )}
          >
            obchodními podmínkami
          </WrapMeWith>
          .
        </Trans>
      }
      legalNoticeText={
        <Trans>
          Prodávající bere na vědomí, že kupující nemá povinnost tento návrh
          akceptovat. Kupní smlouva vzniká konfirmací tohoto závazného návrhu ze
          strany kupujícího.
        </Trans>
      }
      parity={t`FCA - naložený dopravní prostředek ${postalCodeLabel}`}
      traderLabel={t`Kupující`}
    />
  );
};

export { BindingOfferSellDialog };
